<template>
  <modal
    :modal-is-open="modalIsOpen"
    :modal-title="modalTitle"
    :button-text="buttonText"
    @on-close="$emit('on-close')"
  >
    <p>{{ modalText }}</p>
  </modal>
</template>

<style lang="scss" scoped></style>

<script>
import Modal from "./Modal";

export default {
  name: "MessageModal",

  components: {
    Modal
  },

  props: {
    modalIsOpen: {
      type: Boolean,
      required: true
    },
    modalTitle: {
      type: String,
      required: false
    },
    modalText: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: false
    }
  }
};
</script>
